{
  "schema_version": "1.0",
  "run_id": "run_20260712_130000_ist",
  "edition_key": "2026-07-12-1300-Asia-Kolkata",
  "created_at": "2026-07-12T07:32:00Z",
  "language": "hi-Deva",
  "title": "दोपहर की स्रोत-जाँची खबरें",
  "lines": [
    {
      "line_id": "L001",
      "segment_id": "S01",
      "speaker": "ANCHOR_A",
      "line_type": "fact",
      "text": "केंद्रीय मंत्रिमंडल ने बारह हजार करोड़ रुपये की हरित हाइड्रोजन मिशन को मंजूरी दी।",
      "claim_ids": ["C001"],
      "source_ids": ["the-hindu-national"]
    },
    {
      "line_id": "L002",
      "segment_id": "S02",
      "speaker": "ANCHOR_B",
      "line_type": "transition",
      "text": "अब अगली खबर।",
      "claim_ids": [],
      "source_ids": []
    },
    {
      "line_id": "L003",
      "segment_id": "S03",
      "speaker": "ANCHOR_B",
      "line_type": "fact",
      "text": "भारतीय रिज़र्व बैंक ने रेपो दर पाँच दशमलव पाँच प्रतिशत पर बरकरार रखी।",
      "claim_ids": ["C002"],
      "source_ids": ["indian-express-india"]
    },
    {
      "line_id": "L004",
      "segment_id": "S04",
      "speaker": "ANCHOR_A",
      "line_type": "transition",
      "text": "आगे बढ़ते हैं।",
      "claim_ids": [],
      "source_ids": []
    },
    {
      "line_id": "L005",
      "segment_id": "S05",
      "speaker": "ANCHOR_A",
      "line_type": "fact",
      "text": "दिल्ली में दक्षिण-पश्चिम मानसून अपनी सामान्य तिथि से दो दिन पहले पहुँच गया।",
      "claim_ids": ["C003"],
      "source_ids": ["ndtv-latest"]
    },
    {
      "line_id": "L006",
      "segment_id": "S06",
      "speaker": "ANCHOR_B",
      "line_type": "transition",
      "text": "ये थीं आज की सत्यापित खबरें। यह बुलेटिन एआई द्वारा तैयार किया गया है और हर तथ्य स्रोत-जाँचा है।",
      "claim_ids": [],
      "source_ids": []
    }
  ],
  "claims": [
    {
      "claim_id": "C001",
      "story_id": "sha256:story-001",
      "claim_text_hi": "केंद्रीय मंत्रिमंडल ने बारह हजार करोड़ रुपये की हरित हाइड्रोजन मिशन को मंजूरी दी।",
      "claim_text_en": "The Union Cabinet approved the ₹12,000 crore Green Hydrogen Mission.",
      "claim_type": "event",
      "preliminary_source_ids": ["the-hindu-national"]
    },
    {
      "claim_id": "C002",
      "story_id": "sha256:story-002",
      "claim_text_hi": "भारतीय रिज़र्व बैंक ने रेपो दर पाँच दशमलव पाँच प्रतिशत पर बरकरार रखी।",
      "claim_text_en": "The RBI held the repo rate at 5.5%.",
      "claim_type": "event",
      "preliminary_source_ids": ["indian-express-india"]
    },
    {
      "claim_id": "C003",
      "story_id": "sha256:story-003",
      "claim_text_hi": "दिल्ली में दक्षिण-पश्चिम मानसून अपनी सामान्य तिथि से दो दिन पहले पहुँच गया।",
      "claim_text_en": "The southwest monsoon reached Delhi two days before its normal onset date.",
      "claim_type": "event",
      "preliminary_source_ids": ["ndtv-latest"]
    }
  ],
  "word_count": 48,
  "estimated_seconds": 90
}
